module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((_vm.player.shown && _vm.player.url) || (_vm.taskImageFullPath !== '' && !_vm.player.shown)) ? _c('div', {
    staticClass: "task-content-media"
  }, [(_vm.player.shown && _vm.player.url) ? _c('div', {
    staticClass: "task-content-video"
  }, [_c('iframe', {
    attrs: {
      "id": "player",
      "frameborder": "0",
      "webkitAllowFullScreen": "",
      "mozallowfullscreen": "",
      "allowFullScreen": "",
      "height": "340",
      "width": "600",
      "src": _vm.player.url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.taskImageFullPath !== '' && !_vm.player.shown) ? _c('div', {
    staticClass: "task-content-image",
    class: {
      'video-type': _vm.player.url
    },
    style: ({
      backgroundImage: 'url(' + _vm.taskImageFullPath + ')'
    }),
    attrs: {
      "title": _vm.taskImageAlt
    }
  }, [(_vm.player.url) ? _c('div', {
    staticClass: "task-content-video-play",
    on: {
      "click": function($event) {
        return _vm.playVideo()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-play-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "play-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1\n                16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200\n                200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
    }
  })])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.taskContentType === 8 || _vm.taskContentType === 9) ? _c('div', {
    staticClass: "task-content-resources"
  }, [_c('div', {
    staticClass: "task-content-resources-items"
  }, _vm._l((_vm.taskResources), function(resource) {
    return (resource.file) ? _c('a', {
      attrs: {
        "href": "#",
        "role": "button",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadFile(resource)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-circle-down fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-circle-down",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288\n             302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4\n             9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(resource.name ? resource.name : resource.file))])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-content-text",
    domProps: {
      "innerHTML": _vm.taskContent
    }
  }), _vm._v(" "), (_vm.related && _vm.related.length) ? _c('div', {
    staticClass: "task-content-related"
  }, [_c('div', {
    staticClass: "task-content-related-header"
  }, [_vm._v("\n      Related resources\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "task-content-related-list"
  }, _vm._l((_vm.related), function(item) {
    return _c('li', {
      staticClass: "task-content-related-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          'name': 'content',
          'params': {
            'id': item.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "task-content-related-icon"
    }, [(item.contentType === 7) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "play",
        "d": "M20.068,15.367l-6.188-3.762c-0.408-0.226-0.922-0.079-1.149,0.329\n                      c-0.069,0.125-0.106,0.266-0.106,0.409v7.313c0.001,0.467,0.381,0.845,0.849,0.843c0.142,0,0.282-0.037,0.406-0.105l6.188-3.55\n                      c0.408-0.228,0.554-0.743,0.326-1.151C20.317,15.556,20.205,15.443,20.068,15.367z M24.719,16c0.001-4.814-3.901-8.718-8.715-8.719\n                      c-0.001,0-0.003,0-0.004,0c-4.814-0.001-8.718,3.901-8.719,8.715c0,0.001,0,0.003,0,0.004c-0.001,4.814,3.901,8.718,8.715,8.719\n                      c0.001,0,0.003,0,0.004,0c4.814,0.001,8.718-3.901,8.719-8.715C24.719,16.003,24.719,16.001,24.719,16z M8.969,16\n                      c-0.001-3.882,3.145-7.03,7.027-7.031c0.001,0,0.003,0,0.004,0c3.882-0.001,7.03,3.145,7.031,7.027c0,0.001,0,0.003,0,0.004\n                      c0.001,3.882-3.145,7.03-7.027,7.031c-0.001,0-0.003,0-0.004,0c-3.882,0.001-7.03-3.145-7.031-7.027\n                      C8.969,16.003,8.969,16.001,8.969,16z"
      }
    })])])] : (item.contentType === 8) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-pdf",
        "d": "M22.254,10.446L19.3,7.496c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17\n                        c-0.934,0.003-1.69,0.762-1.688,1.696v14.625c0.001,0.932,0.756,1.687,1.688,1.687h10.125c0.931-0.001,1.686-0.756,1.687-1.687\n                        V11.641C22.749,11.193,22.57,10.763,22.254,10.446z M20.925,11.504H18.25V8.829L20.925,11.504z M10.938,23.317V8.692h5.625v3.656\n                        c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v10.125H10.938z M19.738,18.265\n                        c-0.438-0.422-1.657-0.311-2.268-0.229c-0.609-0.374-1.067-0.95-1.294-1.628c0.211-0.634,0.276-1.307,0.19-1.969\n                        c-0.054-0.43-0.446-0.734-0.876-0.68c-0.277,0.035-0.515,0.215-0.624,0.473c-0.105,0.795-0.02,1.603,0.248,2.359\n                        c-0.37,0.893-0.785,1.766-1.244,2.616c-0.7,0.362-1.652,0.921-1.793,1.624c-0.116,0.555,0.914,1.941,2.675-1.1\n                        c0.782-0.293,1.584-0.529,2.4-0.707c0.602,0.343,1.272,0.548,1.962,0.6c0.448,0.011,0.821-0.343,0.832-0.792\n                        c0.005-0.209-0.071-0.413-0.212-0.567H19.738z M12.769,21c0.273-0.476,0.636-0.893,1.069-1.23\n                        C13.17,20.834,12.769,21.024,12.769,21z M15.638,14.3c0.26,0,0.236,1.129,0.063,1.434c-0.139-0.466-0.161-0.959-0.063-1.435V14.3z\n                         M14.78,19.1c0.338-0.618,0.628-1.26,0.868-1.922c0.26,0.487,0.621,0.912,1.059,1.248C16.047,18.595,15.402,18.821,14.78,19.1\n                        L14.78,19.1z M19.407,18.924c0,0-0.176,0.212-1.307-0.27C19.329,18.56,19.533,18.841,19.407,18.924L19.407,18.924z"
      }
    })])])] : (item.contentType === 9) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-alt",
        "d": "M19.375,15.719c-0.001-0.234-0.19-0.423-0.424-0.422H18.95h-5.9\n                        c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9c0.233-0.001,0.421-0.189,0.422-0.422\n                        L19.375,15.719z M18.95,18.25h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9\n                        c0.233-0.001,0.421-0.189,0.422-0.422v-0.984C19.371,18.439,19.183,18.251,18.95,18.25z M22.75,11.637\n                        c-0.002-0.446-0.182-0.873-0.5-1.187L19.3,7.5c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17C10.006,7,9.25,7.756,9.25,8.688v14.625\n                        C9.251,24.245,10.006,25,10.938,25h10.125c0.931-0.001,1.686-0.756,1.687-1.687V11.637z M18.25,8.825l2.675,2.675H18.25V8.825z\n                         M21.063,23.313H10.938V8.688h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656V23.313z"
      }
    })])])] : (item.contentType === 10) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M24.438,7H7.563C6.631,7,5.875,7.756,5.875,8.688v11.25c0.001,0.932,0.756,1.687,1.688,1.687h6.75\n                        l-0.563,1.688h-2.531c-0.466,0-0.844,0.378-0.844,0.844S10.753,25,11.219,25h9.563c0.466-0.016,0.831-0.407,0.814-0.872\n                        c-0.015-0.443-0.371-0.799-0.814-0.814H18.25l-0.562-1.687h6.75c0.932-0.001,1.688-0.757,1.687-1.689V8.688\n                        C26.125,7.756,25.37,7.001,24.438,7z M23.875,19.375H8.125V9.25h15.75V19.375z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,13.25h9c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-9c-0.276,0-0.5,0.224-0.5,0.5v1\n                        C10.375,13.026,10.599,13.25,10.875,13.25z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,17.25h6c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276,0-0.5,0.224-0.5,0.5v1\n                        C10.375,17.025,10.599,17.25,10.875,17.25z"
      }
    })])])])] : (item.contentType === 11) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M17.7,14.421h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.514\n                        c0.245-0.097,0.498-0.177,0.76-0.236c0.028-0.057,0.048-0.118,0.048-0.186l0.003-0.984C18.124,14.609,17.935,14.42,17.7,14.421\n                        C17.701,14.421,17.7,14.421,17.7,14.421z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M11.378,17.796v0.984c0.001,0.233,0.189,0.421,0.422,0.422h2.571c0.272-0.693,0.68-1.316,1.203-1.828H11.8\n                        C11.567,17.375,11.379,17.563,11.378,17.796z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M9.688,22.437V7.812h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v3.62\n                        c0.599,0.067,1.166,0.225,1.687,0.477v-5.648c-0.002-0.446-0.182-0.873-0.5-1.187l-2.95-2.95c-0.315-0.318-0.744-0.498-1.192-0.5\n                        h-7.17C8.756,6.124,8,6.88,8,7.812v14.625c0.001,0.932,0.756,1.687,1.688,1.687h5.28c-0.356-0.503-0.615-1.074-0.776-1.687H9.688z\n                         M17,7.949l2.675,2.675H17V7.949z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M23.891,24.791l-1.558-1.558c-0.071-0.07-0.166-0.109-0.266-0.109h-0.254c0.447-0.571,0.689-1.275,0.688-2\n                        c0.001-1.794-1.454-3.249-3.248-3.25c-0.001,0-0.002,0-0.003,0c-1.794-0.001-3.249,1.454-3.25,3.248c0,0.001,0,0.001,0,0.002\n                        c-0.001,1.794,1.454,3.249,3.248,3.25c0.001,0,0.001,0,0.002,0c0.725,0.002,1.429-0.24,2-0.687v0.255\n                        c0,0.1,0.039,0.195,0.109,0.266l1.558,1.557c0.145,0.146,0.381,0.147,0.528,0.003c0.001-0.001,0.002-0.002,0.003-0.003\n                        l0.442-0.443C24.035,25.176,24.036,24.939,23.891,24.791z M19.25,23.124c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2\n                        S20.355,23.124,19.25,23.124z"
      }
    })])])])] : _vm._e()], 2), _vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96289714","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tasks/includes/TaskContent.vue
// module id = 982
// module chunks = 1